var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialized)?_c('v-sparkline',{attrs:{"type":"bar","labels":_vm.labels,"value":_vm.value,"color":"white","line-width":"20","padding":"16"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }